import { render, staticRenderFns } from "./buyerItem.vue?vue&type=template&id=079b11d8&"
import script from "./buyerItem.vue?vue&type=script&lang=js&"
export * from "./buyerItem.vue?vue&type=script&lang=js&"
import style0 from "./buyerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports